<template lang="pug">
.content.result-content
  .row.result-body
    .col-md-12
      .header Bài tập đã làm của tôi
      .row
        .no-data.col-md-12(v-if="results.length === 0") Không có dữ liệu
        .result-items(v-for="(item, index) in results")
          .col-md-6.col-sm-12.col-xs-12.box-item-result
            .card.card-result-total
              .box-result-info(@click="onDoExercise(item.exercise_id)")
                .img-result
                  img(:src="item.exercise.userCreate.avatar" v-if="item.exercise.userCreate.avatar && item.exercise.userCreate.avatar !== undefined  && item.exercise.userCreate.avatar !== null && item.exercise.userCreate.avatar.length > 0")
                  img(src="../../../assets/images/faces/ic_AvatarDefault.svg" v-else)
                .item-info
                  span.fullname {{item.exercise.userCreate.fullname}}
                  span.subjects {{item.exercise.subject.name}}
                  span.grades {{getValue(item.exercise.exercise_grades)}}
              .name-result(@click="onDoExercise(item.exercise_id)")
                p {{item.name}}
              .box-info(@click="onDoExercise(item.exercise_id)" v-if="item.class_id !== null")
                .ic-pc
                  img(:src="item.class.private_community.icon" v-if="item.class.private_community.icon && item.class.private_community.icon !== undefined  && item.class.private_community.icon !== null && item.class.private_community.icon.length > 0")
                  img(src="../../../assets/images/faces/ic_AvatarDefault.svg" v-else)
                .item-info
                  span.pc {{item.class.private_community.name}}
                  span.class {{item.class.name}}
                .clearfix
              .box-point(:style="item.class_id === null ? 'margin-top: 8px;' : ''")
                .fas.fa-fist-raised
                span Điểm lần đầu tiên
                span(@click="onDoExercise(item.exercise_id, true)") {{item.total_score}} điểm
              .box-time(@click="onDoExercise(item.exercise_id)")
                .fas.fa-calendar
                span Lần cuối hoạt động {{formatDate(item.lastDate)}}
          .div(:class="index % 2 ? 'clearfix' : ''")

</template>

<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphql'
// import graphqlfront from '../../Model/graphqlfront'
import jQuery from 'jquery'
import moment from 'moment'
export default {
  components: {
    jQuery,
    moment
  },
  data() {
    return {
      offset: 0,
      limit: 10,
      results: [],
      lastResult: null,
      pcInfo: null,
      objLast: null,
      loader: null
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    async onDoExercise(exerciseID, result = false) {
      await this.getInfoPC(exerciseID)
      if (this.pcInfo !== null) {
        let link = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + this.getLinkMore()
        // để làm mới bài tập (đóng bài cũ, mở bài mới)
        if (!result) localStorage.setItem('renew', 1)
        window.location.href = !result ? (link + '/exercise/detail/' + exerciseID) : (link + '/exercise/detail/' + exerciseID + '/result')
      }
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        // zIndex: 100,
        container: null,
        canCancel: false
      })
    },
    getLinkMore() {
      return 'landing/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id
    },
    async getInfoPC(exerciseID) {
      const res = await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_OF_PC),
        variables: {
          where: {
            exercise_ids: {'_contains': exerciseID},
            is_delete: {'_eq': false}
          }
        }
      })
      if (res.data.classes && res.data.classes.length > 0) {
        this.pcInfo = res.data.classes[0].private_community
      }
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm')
    },
    async getLastDateActivity(item) {
      let objWhere = {
        exercise_id: {'_eq': item.exercise_id},
        is_delete: {'_eq': false},
        status: {'_eq': 3},
        created_by: {'_eq': this.$store.getters.user}
      }
      // let {data} = await this.$apollo.query({
      //   query: gql(graphql.GET_RESULTS),
      //   fetchPolicy: 'no-cache',
      //   variables: {
      //     where: objWhere,
      //     order_by: {id: 'desc'}
      //   }
      // }).catch((error) => {
      //   if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
      //     this.$router.go(0)
      //   }
      //   console.error(error)
      // })
      // console.log(data)
      // if (data && data.result.length === 1) {
      if (item.id) {
        this.$delete(objWhere, 'status')
        objWhere = Object.assign(objWhere, {status: {'_eq': 2}})
        let kq = await this.$apollo.query({
          query: gql(graphql.GET_RESULTS),
          fetchPolicy: 'no-cache',
          variables: {
            where: objWhere,
            order_by: {id: 'desc'}
          }
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
          console.error(error)
        })
        if (kq.data && kq.data.result.length > 0) {
          // console.log(kq.data.result[0])
          this.objLast = kq.data.result[0]
        }
      }
    },
    getValue(data) {
      let value = []
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          value.push(data[i].grade.name)
        }
      }
      return value.join('; ')
    }
  },
  async created() {
    if (this.$store.getters.user !== null) {
      this.show()
      await this.$apollo.query({
        query: gql(graphql.GET_RESULTS),
        variables: {
          where: {
            is_delete: {'_eq': false},
            status: {'_eq': 3},
            created_by: {'_eq': this.$store.getters.user}
          },
          order_by: {created_at: 'desc'}
        },
        fetchPolicy: 'no-cache',
        error(error) {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
        }
      }).then(async (res) => {
        // console.log(res)
        if (res && res.data && res.data.result != null) {
          let lstResults = res.data.result
          for (let i = 0; i < lstResults.length; i++) {
            await this.getLastDateActivity(lstResults[i])
            lstResults[i].lastDate = this.objLast !== null ? this.objLast.updated_at : lstResults[i].updated_at
          }
          this.results = [...lstResults]
          this.loader.hide()
        }
      }).catch((error) => {
        this.loader.hide()
        if (error.graphQLErrors && error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/sass/md/_obee';

.result-content {
  padding-top: 20px !important;
}
.result-body {
  .header {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #5F6468;
  }
  .no-data {text-transform: uppercase; text-align: center;}
  .result-items {
    .box-item-result {
      padding-right: 7.5px;
    }
    &:nth-child(2n) {
      .box-item-result {padding-left: 7.5px; padding-right: 15px;}
    }
  }
  .card-result-total {
    margin-bottom: 0px;
    margin-top: 15px;
    border-radius: 10px;
    .box-result-info {
      padding: 15px 15px 8px 15px;
      .img-result {
        width: 40px;
        height: 40px;
        position: relative;
        display: inline-flex;
        border-radius: 50%;
        overflow: hidden;
        img {max-width: 100%; height: auto; width: 100%;position: absolute; margin-top: 5px;}
      }
      .item-info{display: inline-block;margin-left:10px;vertical-align: top; width: calc(100% - 50px);
        span.fullname{display:block;color:#4B2D15; font-size:15px; text-align: left;}
        span.subjects{display: inline-block;color:#3A9F00;font-size:15px; width: 40%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom; text-align: left;}
        span.grades{display: inline-block;color:#9F6A28;font-size:15px; width: 60%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom; text-align: left;}
      }
    }
    .name-result {
      background: #FBF4D2; 
      padding: 16px;
      display: block;
      p {
        display: -webkit-box;
        -webkit-box-orient: vertical; // not working
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        -webkit-line-clamp: 3;
        margin: 0;
        height: 60px;
        text-align: justify;
        font-size: 15px;
        // @include multiLineEllipsis($lineHeight: 1.1em, $lineCount: 3, $bgColor: #FBF4D2); 
      }
    }
    .box-info {
      padding: 8px 16px;
      .ic-pc {
        width: 16px;
        display: inline-flex;
        border-radius: 50%;
        overflow: hidden;
        img {max-width: 100%; height: auto; width: 100%;}
      }
      .item-info{display: inline-block;margin-left:10px;vertical-align: top; width: calc(100% - 26px);
        span.pc{display:block; font-size:14px; color: #343A40; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom;}
        span.class{display: inline-block; color: #343A40; font-size:14px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom;}
      }
    }
    .box-point {padding: 0 16px 8px 16px;
      span {margin-left: 10px; color: #343A40;
        &:nth-child(2n + 1) {margin-left: 4px; text-decoration: underline; color:#343A40; cursor: pointer;}
      }
    }
    .box-time {padding: 0 16px 16px 16px;
      span {margin-left: 10px; color: #343A40;}
    }
  }
}
@media (max-width: 414px) {
  .result-content {
    padding-top: 0px !important;
  }
  .result-body {
    .result-items {
      .box-item-result {padding-right: 15px;}
      &:nth-child(2n) {
        .box-item-result {padding-left: 15px;}
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?4d448944